module.exports = __webpack_public_path__ + "img/26.9bb69c9c.webp";